(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("odometer"));
	else if(typeof define === 'function' && define.amd)
		define(["odometer"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("odometer")) : factory(root["Odometer"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_odometer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_odometer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_odometer__);




var IOdometer = {
  __odometer__: __WEBPACK_IMPORTED_MODULE_1_odometer___default.a,
  name: 'IOdometer',
  props: {
    value: {
      type: Number,
      required: false,
      default: 0
    },
    format: {
      type: String,
      required: false
    },
    theme: {
      type: String,
      required: false,
      default: 'default'
    },
    duration: {
      type: Number,
      required: false
    },
    animation: {
      type: String,
      required: false
    },
    formatFunction: {
      type: Function,
      required: false
    }
  },
  data: function data() {
    return {
      instance: null
    };
  },

  watch: {
    value: {
      handler: function handler(value) {
        var that = this;
        if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.update)) {
          that.instance.update(value);
        }
      },
      deep: false
    }
  },
  methods: {
    auto: function auto() {
      if (typeof window === 'undefined') {
        return;
      }

      if (window.odometerOptions) {
        window.odometerOptions['auto'] = false;
      } else {
        window.odometerOptions = {
          auto: false
        };
      }
    },
    init: function init() {
      var that = this;
      if (that.instance) {
        return;
      }

      that.auto();

      var dom = that.$el;
      var instance = new __WEBPACK_IMPORTED_MODULE_1_odometer___default.a({
        el: dom,
        value: that.value,
        format: that.format,
        theme: that.theme,
        duration: that.duration,
        animation: that.animation,
        formatFunction: that.formatFunction
      });

      instance.render();
      that.$emit('ready', instance, __WEBPACK_IMPORTED_MODULE_1_odometer___default.a);
      that.instance = instance;
    },
    uninit: function uninit() {
      var that = this;
      that.instance = null;
    },
    renderInside: function renderInside() {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.renderInside)) {
        that.instance.renderInside();
      }
    },
    watchForMutations: function watchForMutations() {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.watchForMutations)) {
        that.instance.watchForMutations();
      }
    },
    startWatchingMutations: function startWatchingMutations() {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.startWatchingMutations)) {
        that.instance.startWatchingMutations();
      }
    },
    stopWatchingMutations: function stopWatchingMutations() {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.stopWatchingMutations)) {
        that.instance.stopWatchingMutations();
      }
    },
    cleanValue: function cleanValue(val) {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.cleanValue)) {
        that.instance.cleanValue(val);
      }
    },
    bindTransitionEnd: function bindTransitionEnd() {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.bindTransitionEnd)) {
        that.instance.bindTransitionEnd();
      }
    },
    resetFormat: function resetFormat() {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.resetFormat)) {
        that.instance.resetFormat();
      }
    },
    renderDigit: function renderDigit() {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.renderDigit)) {
        that.instance.renderDigit();
      }
    },
    formatDigits: function formatDigits(value) {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.formatDigits)) {
        that.instance.formatDigits(value);
      }
    },
    insertDigit: function insertDigit(digit, before) {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.insertDigit)) {
        that.instance.insertDigit(digit, before);
      }
    },
    addDigit: function addDigit(value, repeating) {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.addDigit)) {
        that.instance.addDigit(value, repeating);
      }
    },
    addSpacer: function addSpacer(chr, before, extraClasses) {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.addSpacer)) {
        that.instance.addSpacer(chr, before, extraClasses);
      }
    },
    animate: function animate(newValue) {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.animate)) {
        that.instance.animate(newValue);
      }
    },
    animateCount: function animateCount(newValue) {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.animateCount)) {
        that.instance.animateCount(newValue);
      }
    },
    getDigitCount: function getDigitCount() {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.getDigitCount)) {
        that.instance.getDigitCount();
      }
    },
    getFractionalDigitCount: function getFractionalDigitCount() {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.getFractionalDigitCount)) {
        that.instance.getFractionalDigitCount();
      }
    },
    resetDigits: function resetDigits() {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.resetDigits)) {
        that.instance.resetDigits();
      }
    },
    animateSlide: function animateSlide(value) {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.animateSlide)) {
        that.instance.animateSlide(value);
      }
    },
    render: function render(value) {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.render)) {
        that.instance.render(value);
      }
    },
    update: function update(newVal) {
      var that = this;
      if (that.instance && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(that.instance.update)) {
        that.instance.update(newVal);
      }
    }
  },
  mounted: function mounted() {
    var that = this;

    that.init();
  },
  beforeDestroy: function beforeDestroy() {
    var that = this;

    that.uninit();
  },
  render: function render(h) {
    return h('span', {});
  }
};

/* harmony default export */ __webpack_exports__["default"] = (IOdometer);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2),
    isObject = __webpack_require__(3);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// vue-odometer.js